module.exports = __webpack_public_path__ + "img/supporting_doc_color.10dae4f3.svg";